import { useBoolean, useToast } from '@chakra-ui/react'
import * as crypto from 'crypto-js'
import fileDownload from 'js-file-download'
import { createContext, FC, useCallback, useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'

import { paramsToSendMapping } from '@helper/alert/paramsToSendMapping'
import { validateGroupName } from '@helper/alert/validateGroupNamePurchase'
import { parsePurchaseAlertData } from '@helper/grid/alert/purchase'
import {
  decrypterHeaderStorange,
  encrypteHeaderStorange
} from '@helper/util/cryptoStorange'
import alert from '@service/alert'

import { ILayoutFilter } from '@base/@types/components/Layout/Filters'
import { ITableHeader } from '@base/@types/components/Layout/TableGrid'
import { ILayoutToolsAction } from '@base/@types/components/Layout/Tools'
import {
  IPurchaseAlertContext,
  IParamsToSend,
  QuantityPurchase,
  Pagination,
  IUpdateParams
} from '@base/@types/providers/Alert/PurchaseProvider'
import { purchaceFilter } from '@base/variables/filters/alerts/purshaceFilter'
import { purchaceRequest } from '@base/variables/filters/alerts/purshaceRequest'
import PurchaseAlertHeader from '@base/variables/headers/alert/purchase'
const PurchaseAlertProvider: FC = ({ children }) => {
  const toast = useToast()
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useBoolean(true)
  const filtersList: ILayoutFilter[] = purchaceFilter
  const [query, setQuery] = useState('')
  const [filename] = useState('Alertas de Compra')

  const [data, updateData] = useImmer<any[]>([])

  const [params, updateParams] = useImmer<any>(purchaceRequest)
  const [quantity, updateQuantity] = useState<QuantityPurchase>({
    total: 0,
    compra: 0,
    recebimento: 0
  })
  const [pagination, updatePagination] = useImmer<Pagination>({
    actualPage: 0,
    rows: 0,
    totalPages: 0,
    totalRows: 0,
    skip: 0
  })
  const [headers, updateHeaders] = useImmer<ITableHeader[]>(PurchaseAlertHeader)
  const [paramsToSend, setParamsToSend] = useState<IParamsToSend>(() => {
    const paramsFormatted = { ...purchaceRequest }

    return paramsFormatted
  })

  const handleupdateQuantity = useCallback(
    async (data: any) => {
      const obj = {
        total: data.length,
        compra: data.filter((x: any) => x.alertaCompra).length,
        recebimento: data.filter((x: any) => x.receberAlerta).length
      }
      updateQuantity(obj)
    },
    [updateQuantity]
  )

  const clearAllFilters = () => {
    const paramsFormatted = { ...purchaceRequest }

    updateParams({
      ...params,
      empresaIds: false,
      empresaSelectIds: [],
      centroCdLojaIds: false,
      centroCdLojaSelectIds: [],
      gerenteCategoriaIds: false,
      gerenteCategoriaSelectIds: [],
      gerenteProdutoIds: false,
      gerenteProdutoSelectIds: [],
      mundoIds: false,
      mundoSelectIds: [],
      categoriaCompactaIds: false,
      categoriaCompactaSelectIds: [],
      categoriaIds: false,
      categoriaSelectIds: [],
      curvaAbcIds: false,
      curvaAbcSelectIds: [],
      fornecedorSelectIds: []
    })
    setParamsToSend(paramsFormatted)
    if (localStorage.getItem('alertPurchaseParams')) {
      localStorage.setItem(
        'alertPurchaseParams',
        crypto.AES.encrypt(
          JSON.stringify({
            ...params,
            empresaIds: false,
            empresaSelectIds: [],
            centroCdLojaIds: false,
            centroCdLojaSelectIds: [],
            gerenteCategoriaIds: false,
            gerenteCategoriaSelectIds: [],
            gerenteProdutoIds: false,
            gerenteProdutoSelectIds: [],
            mundoIds: false,
            mundoSelectIds: [],
            categoriaCompactaIds: false,
            categoriaCompactaSelectIds: [],
            categoriaIds: false,
            categoriaSelectIds: [],
            curvaAbcIds: false,
            curvaAbcSelectIds: [],
            fornecedorSelectIds: []
          }),
          'CHAVE'
        ).toString()
      )
    }
    if (localStorage.getItem('alertPurchaseParamsRequest')) {
      localStorage.setItem(
        'alertPurchaseParamsRequest',
        crypto.AES.encrypt(JSON.stringify(paramsFormatted), 'CHAVE').toString()
      )
    }
  }

  const handleUpdateParams = ({ name, value }: IUpdateParams) => {
    updateParams((draft: { [x: string]: string }) => {
      draft[name] = value
    })

    const paramsToSendFormatted = paramsToSendMapping({
      name,
      value,
      compareName: name,
      paramsToSend,
      fieldName: validateGroupName(name)
    })

    setParamsToSend(paramsToSendFormatted)
    if (localStorage.getItem('alertPurchaseParams')) {
      const newParams: IParamsToSend[] = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('alertPurchaseParams'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )

      localStorage.setItem(
        'alertPurchaseParams',
        crypto.AES.encrypt(
          JSON.stringify({ ...newParams, [name]: value }),
          'CHAVE'
        ).toString()
      )
    }
    if (localStorage.getItem('alertPurchaseParamsRequest')) {
      localStorage.setItem(
        'alertPurchaseParamsRequest',
        crypto.AES.encrypt(
          JSON.stringify(paramsToSendFormatted),
          'CHAVE'
        ).toString()
      )
    }
  }

  const handleLocalParams = useCallback(async () => {
    if (localStorage.getItem('alertPurchaseParams')) {
      const newParams = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('alertPurchaseParams'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )
      updateParams(newParams)
    } else {
      localStorage.setItem(
        'alertPurchaseParams',
        crypto.AES.encrypt(JSON.stringify(params), 'CHAVE').toString()
      )
    }
    if (localStorage.getItem('alertPurchaseParamsRequest')) {
      const newParams = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('alertPurchaseParamsRequest'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )
      setParamsToSend(newParams)
    } else {
      localStorage.setItem(
        'alertPurchaseParamsRequest',
        crypto.AES.encrypt(JSON.stringify(paramsToSend), 'CHAVE').toString()
      )
    }
  }, [updateParams, setParamsToSend, params, paramsToSend])

  const handleHeaderLocalStorange = useCallback(() => {
    if (!localStorage.getItem('alertPurchaseHeader')) {
      encrypteHeaderStorange('alertPurchaseHeader', headers)
    } else {
      localStorage.removeItem('alertPurchaseHeader')
      encrypteHeaderStorange('alertPurchaseHeader', headers)
    }
  }, [headers])

  const toggleColumn = useCallback(
    (index: number, column: number) => {
      const newHeaders = [...headers]

      newHeaders[index].columns[column] = {
        id: newHeaders[index].columns[column].id,
        name: newHeaders[index].columns[column].name,
        show: !newHeaders[index].columns[column].show,
        notShowColumn: newHeaders[index].columns[column].notShowColumn
          ? !newHeaders[index].columns[column].notShowColumn
          : true
      }

      updateHeaders(newHeaders)
      handleHeaderLocalStorange()
    },
    [handleHeaderLocalStorange, headers, updateHeaders]
  )

  const actions = useMemo<ILayoutToolsAction[]>(() => {
    return [
      {
        type: 'export',
        exports: [
          {
            type: 'excel',
            entity: 'alertPurchase',
            data,
            headers
          }
        ]
      },
      {
        type: 'columns',
        data: headers,
        onToggleColumn: toggleColumn
      }
    ]
  }, [toggleColumn, headers, data])

  const exportData = useCallback(async () => {
    const alertGrid = {
      configuracaoGrid: {
        alertasCompra: headers[0].columns[0]
          ? headers[0].columns[0].show
          : true,
        alertasReceber: headers[0].columns[1]
          ? headers[0].columns[1].show
          : true,
        estoqueAtual: headers[5].columns[0] ? headers[5].columns[0].show : true,
        estoqueTransito: headers[5].columns[1]
          ? headers[5].columns[1].show
          : true,
        coberturaAtual: headers[5].columns[2]
          ? headers[5].columns[2].show
          : true,
        centro: headers[1].columns[0] ? headers[1].columns[0].show : true,
        vendaMediaDiaria: headers[0].columns[0]
          ? headers[0].columns[0].show
          : true,
        estoqueMinimo: headers[0].columns[0]
          ? headers[0].columns[0].show
          : true,
        estoqueMinimoLT: headers[0].columns[0]
          ? headers[0].columns[0].show
          : true,
        produtoCodigo: headers[2].columns[0]
          ? headers[2].columns[0].show
          : true,
        produtoMaterial: headers[2].columns[1]
          ? headers[2].columns[1].show
          : true,
        produtoCurvaABC: headers[2].columns[3]
          ? headers[2].columns[3].show
          : true,
        produtoCurvaABCEmpresa: headers[2].columns[4]
          ? headers[2].columns[4].show
          : true,
        fornecedorCodigo: headers[3].columns[0]
          ? headers[3].columns[0].show
          : true,
        fornecedorNome: headers[3].columns[1]
          ? headers[3].columns[1].show
          : true,
        fornecedorLeadTime: headers[3].columns[2]
          ? headers[3].columns[2].show
          : true,
        subCategoriaNome: true
      }
    }

    Swal.fire({
      title: 'Exportar dados!',
      html: 'Aguarde um momento<b></b>.',
      timerProgressBar: true,
      timer: 9999,
      didOpen: () => {
        Swal.showLoading()
      }
    })

    const arr = { ...paramsToSend, ...alertGrid }
    try {
      const { data: res } = await alert.postExportAlertPurchase(
        arr,
        paramsToSend
      )
      Swal.close()
      fileDownload(res, filename + '.csv')
    } catch (error: any) {
      const { data } = error.response
      Swal.close()
      const message =
        data.response?.status === 400
          ? data.response?.data?.data[0].message
          : 'Ocorreu um problema interno. Tente novamente mais tarde'
      toast({
        title: 'Atenção.',
        description: message,
        status: 'warning',
        duration: 2000,
        isClosable: true
      })
    }
  }, [toast, filename, headers, paramsToSend])

  const handlePageChange = useCallback(
    async (page: number) => {
      setLoading(true)

      localStorage.setItem(
        '@AlertPurchaseParamsToSend:',
        crypto.AES.encrypt(JSON.stringify(paramsToSend), 'CHAVE').toString()
      )

      alert
        .getPurschaseData(paramsToSend, page)
        .then(({ data: { data, pagination } }) => {
          updateData(draft => {
            return draft.filter(item => item.status === 99).concat(data)
          })
          handleupdateQuantity(data)

          updatePagination(pagination)
          setLoading(false)
        })
        .catch(() => updateData([]))
      setLoading(false)
    },
    [paramsToSend, updateData, updatePagination, handleupdateQuantity]
  )

  const handleStorange = useCallback(async () => {
    if (localStorage.getItem('alertPurchaseHeader')) {
      const newHeader = decrypterHeaderStorange('alertPurchaseHeader')
      updateHeaders(newHeader)
    }
  }, [updateHeaders])

  const getData = useCallback(async () => {
    setLoading(true)
    // await getMaintence()
    encrypteHeaderStorange('alertPurchaseHeader', headers)

    handleStorange()
    let newParams = {}
    if (localStorage.getItem('alertPurchaseParamsRequest')) {
      newParams = JSON.parse(
        crypto.AES.decrypt(
          localStorage.getItem('alertPurchaseParamsRequest'),
          'CHAVE'
        ).toString(crypto.enc.Utf8) || ''
      )
    } else {
      newParams = paramsToSend
    }

    alert
      .getPurschaseData(newParams, 1)
      .then(({ data: { data, pagination } }) => {
        updateData(draft => {
          return draft.filter(item => item.status === 99).concat(data)
        })
        handleupdateQuantity(data)
        updatePagination(pagination)
        setFilters.toggle()
        setLoading(false)
      })
      .catch(() => {
        updateData([])
        setLoading(false)
      })
  }, [
    headers,
    handleStorange,
    paramsToSend,
    updateData,
    handleupdateQuantity,
    updatePagination,
    setFilters
  ])
  return (
    <PurchaseAlertContext.Provider
      value={{
        loading,

        filtersList,
        query,
        setQuery,
        pagination,

        data: parsePurchaseAlertData(data),
        actions,
        handleLocalParams,
        params,
        handlePageChange,
        quantity,
        exportData,

        headers,
        filename,
        filters,

        toggleColumn,
        clearAllFilters,
        handleUpdateParams,

        getData,

        setFilters
      }}
    >
      {children}
    </PurchaseAlertContext.Provider>
  )
}

export default PurchaseAlertProvider
export const PurchaseAlertContext = createContext<IPurchaseAlertContext>(
  {} as IPurchaseAlertContext
)
